import { graphql } from "../gql";

export const createAgentDemoMutationDoc = graphql(`
  mutation createAgentDemo($input: DemoAgentInput!) {
    createAgentDemo(input: $input) {
      ...DemoAgentResultFragment
    }
  }
`);
